const cachios = require('cachios');
const axios = require('axios');

const apiUrl = (location.hostname === 'localhost') ? 'http://localhost:3000/portal/' 
: ((location.hostname === 'staging-portal.my247ed.com')
? 'https://staging-api.my247ed.com/portal/'
: 'https://api.my247ed.com/portal/');
const axiosInstance = axios.create({
    baseURL:  apiUrl
});

import axiosRetry from 'axios-retry';

axiosRetry(axiosInstance, {
    retries: 10,
    retryDelay: axiosRetry.exponentialDelay
});

// all requests will now use this axios instance
// const client = cachios.create(axiosInstance, {
//     stdTTL: 120
// });

let client = axiosInstance;

export {client, axiosInstance, apiUrl};
